<script setup>
</script>

<template>
  <div class="py-4 container-fluid">
    <router-view />
  </div>
</template>